import { useEffect, useState } from 'react'
import {
  DatePickerInput,
  DatesRangeValue,
  DateValue,
  type DatePickerInputProps,
} from '@mantine/dates'
import { useDebouncedCallback } from '@mantine/hooks'
import dayjs from 'dayjs'
import AppIcon from '../common/AppIcon'

interface AppRangePickerProps
  extends Omit<
    DatePickerInputProps<'range'>,
    'name' | 'value' | 'defaultDate' | 'defaultValue'
  > {
  label?: string
  placeholder?: string
  name?: string
  value?: DatesRangeValue | undefined
  onChange?: (v: any) => void
  debounced?: boolean
}
function AppRangePicker({
  label,
  placeholder = label || 'Selecciona dos fechas',
  name,
  value,
  onChange,
  debounced = true,
  ...other
}: AppRangePickerProps) {
  const [localValue, setLocalValue] = useState<
    [DateValue | null, DateValue | null]
  >([null, null])

  useEffect(() => {
    const safeValue = value ?? [null, null]
    setLocalValue([safeValue[0] || null, safeValue[1] || null])
  }, [value])

  const debouncedOnChange = useDebouncedCallback(
    (v: any) => {
      if (v[0] && v[1]) onChange?.(name ? { target: { name, value: v } } : v)
      if (!v[0] && !v[1])
        onChange?.(
          name ? { target: { name, value: [null, null] } } : [null, null],
        )
    },
    300, // milisegundos de debounce
  )

  return (
    <DatePickerInput
      {...other}
      type="range"
      label={label}
      placeholder={placeholder}
      miw={150}
      name={name}
      leftSection={<AppIcon icon={'calendar'} />}
      value={localValue}
      onChange={(val: DatesRangeValue) => {
        const initDate = val[0] ? dayjs(val[0]).startOf('day').toDate() : null
        const endDate = val[1] ? dayjs(val[1]).endOf('day').toDate() : null

        setLocalValue([val[0] || null, val[1] || null])
        if (onChange) {
          if (debounced) debouncedOnChange([initDate, endDate])
          else onChange([initDate, endDate])
        }
      }}
      valueFormat="DD/MM/YYYY"
      locale="es"
    />
  )
}
export default AppRangePicker
